<template>
  <div class="login-page">
    <div class="card login-card">
      <h2 class="login-title">账号登录</h2>
      <p class="login-tip">登录后可查询单词、音节、相似词与课本单词</p>

      <el-form :model="form" label-width="60px" @submit.native.prevent>
        <el-form-item label="账号">
          <el-input
            v-model="form.username"
            placeholder="请输入账号"
            clearable
            @keyup.enter.native="submitLogin"
          />
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            v-model="form.password"
            type="password"
            show-password
            placeholder="请输入密码"
            @keyup.enter.native="submitLogin"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            style="width: 100%"
            @click="submitLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async submitLogin() {
      const { username, password } = this.form
      if (!username.trim()) {
        this.$message.warning('请填写账号')
        return
      }
      if (!password.trim()) {
        this.$message.warning('请填写密码')
        return
      }

      this.loading = true
      try {
        // 后端 SaResult：res.data 为 token，res.teacherInfo 为用户信息
        const res = await request.post('/api/teacher/login', {
          username: username.trim(),
          password: password.trim(),
          code: ''
        })
        this.$store.dispatch('setLoginData', {
          token: res.data || '',
          info: res.teacherInfo || null
        })
        this.$message.success('登录成功')
        this.$router.push('/wordinfo')
      } catch (e) {
        // 拦截器已统一弹错
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  padding-top: 40px;
}

.login-card {
  width: 420px;
}

.login-title {
  text-align: center;
  margin-bottom: 8px;
}

.login-tip {
  text-align: center;
  color: #909399;
  font-size: 13px;
  margin-bottom: 24px;
}
</style>
